<template><div><MainView/><Footer/></div></template>
<script>
import MainView from "../components/MainView.vue";
import Footer from "../components/footer.vue";
export default { name:"MainComponent", components:{ MainView, Footer } };
</script>
